import ActionRequired from './containers/ActionRequired';

import React from 'react';

export default ActionRequired;

export {uiDataActionRequired, serverDataActionRequired} from './reducers/ActionRequired';